/* LEDPLANET lp-vangnet.js (30-10-2026): winkelwagen-vangnet. Uitleg, teksten (7 talen) en het formulier staan in snippets/ledplanet-vangnet.
   Data: sections/lp-vangnet-data (echte winkelwagen + voorraad + levertijdgegevens). Levertijd: window.LP_LEVERTIJD (assets/lp-levertijd.js).
   Verzendgrenzen per land: window.LP_VZ (assets/lp-verzendland.js). Mail: zelfde tag-opbouw als assets/lp-toolmail.js (Flow 'Toolmail'). */
(function () {
  'use strict';
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('lp-vn-cfg').textContent); } catch (e) { return; }
  var T = CFG.t || {}, TAAL = CFG.taal || 'nl';
  var ROOT = String(CFG.root || '/').replace(/\/?$/, '/');
  var EL = document.getElementById('lp-vn');
  var qs; try { qs = new URLSearchParams(location.search); } catch (e) { qs = { get: function () { return null; }, has: function () { return false; }, delete: function () {}, toString: function () { return ''; } }; }

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function f(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] !== undefined ? o[k] : ''; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- 1. herstel-link: /cart?lp_wagen=VARIANT:AANTAL;VARIANT:AANTAL ---------- */
  var herstel = qs.get('lp_wagen');
  if (herstel) {
    var upd = {}, ids = [];
    herstel.split(/[;,]/).forEach(function (p) { var m = p.match(/^\s*(\d+):(\d+)\s*$/); if (m && +m[2] > 0) { upd[m[1]] = +m[2]; ids.push(+m[1]); } });
    if (ids.length) {
      var naar = function () { location.replace(ROOT + 'cart'); };
      fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var er = {}; ((c && c.items) || []).forEach(function (i) { er[i.variant_id] = 1; });
          var mis = ids.filter(function (id) { return !er[id]; }).map(function (id) { return { id: id, quantity: upd[id] }; });
          if (!mis.length) return naar();
          return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: mis }) }).then(naar, naar);
        })
        .catch(naar);
      return;
    }
  }

  /* ---------- 2. terug na 'mail mij' ---------- */
  var POSTED = qs.get('lp_vn_ok') === '1' && qs.get('customer_posted') === 'true';
  var FOUT = location.hash === '#lp-vn-form';
  if (qs.has('lp_vn_ok')) {
    qs.delete('lp_vn_ok'); qs.delete('customer_posted');
    var q2 = qs.toString();
    try { history.replaceState(history.state, '', location.pathname + (q2 ? '?' + q2 : '')); } catch (e) {}
  }
  function toast(tekst, fout) {
    var d = document.createElement('div');
    d.className = 'lp-vn-toast' + (fout ? ' lp-vn-toast--fout' : '');
    d.setAttribute('role', 'status');
    d.innerHTML = '<p>' + esc(tekst) + (fout ? '' : '<br><span>Bas / LEDPLANET.NL</span>') + '</p>';
    var x = document.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', T.sluit || 'Sluiten');
    x.addEventListener('click', function () { d.remove(); });
    d.appendChild(x); document.body.appendChild(d);
    setTimeout(function () { if (d.parentNode) d.remove(); }, 12000);
  }
  if (POSTED) { ss('lp_vn', '1'); ls('lp_vn_t', String(Date.now())); setTimeout(function () { toast(T.ok); }, 600); }

  /* ---------- hulpjes: data, land, geld, datums ---------- */
  var DATA = null;
  function haal() {
    return fetch(ROOT + '?sections=lp-vangnet-data', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var h = (j && j['lp-vangnet-data']) || '';
        var m = h.match(/<script[^>]*data-lp-vn-data[^>]*>([\s\S]*?)<\/script>/);
        DATA = m ? JSON.parse(m[1]) : null;
        return DATA;
      });
  }
  var EU = 'AT BG HR CZ DK EE FI FR GR HU IE IT LV LT LU MT NO PL PT RO SK SI ES SE CH GB'.split(' ');
  function land() {
    try { if (window.LP_VZ && LP_VZ.land) return LP_VZ.land(); } catch (e) {}
    try { if (window.LP_LEVERTIJD && LP_LEVERTIJD.land) return LP_LEVERTIJD.land(); } catch (e) {}
    return String((window.Shopify && Shopify.country) || 'NL').toUpperCase();
  }
  function grens(c) {
    try { if (window.LP_VZ && LP_VZ.grens) return LP_VZ.grens(c); } catch (e) {}
    if (c === 'NL' || c === 'BE') return { g: 50, m: 0 };
    if (c === 'DE') return { g: 100, m: 0 };
    if (EU.indexOf(c) > -1) return { g: 150, m: 100 };
    return null;
  }
  function rate() { try { return parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1; } catch (e) { return 1; } }
  var EW = { nl: 'euro', de: 'Euro', en: 'euros', fr: 'euros', es: 'euros', it: 'euro', pl: 'euro' };
  var LOC = document.documentElement.lang || TAAL;
  function geld(cent) {   // huisregel: het woord euro, geen euroteken
    var cur = (DATA && DATA.valuta) || 'EUR', v = cent / 100, s;
    try { s = new Intl.NumberFormat(LOC, { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); } catch (e) { s = v.toFixed(2).replace('.', ','); }
    return s + ' ' + (cur === 'EUR' ? (EW[TAAL] || 'euro') : cur);
  }
  function naam(c) { try { return new Intl.DisplayNames([TAAL], { type: 'region' }).of(c) || c; } catch (e) { return c; } }
  function fmt(d, o) { o.timeZone = 'UTC'; try { return new Intl.DateTimeFormat(TAAL === 'en' ? 'en-GB' : TAAL, o).format(d); } catch (e) { return d.toISOString().slice(0, 10); } }
  function dagen(a, b) { return Math.round((b - a) / 864e5); }
  function kort(d) { return fmt(d, { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '').replace(/,/g, ''); }
  function dagWoord(vandaag, d) {
    var n = dagen(vandaag, d);
    if (n === 1) return T.morgen;
    return f(T.op || '{d}', { d: n <= 6 ? fmt(d, { weekday: 'long' }) : fmt(d, { weekday: 'long', day: 'numeric', month: 'long' }) });
  }
  function duur(min) { var u = Math.floor(min / 60), m = min % 60; return u > 0 ? f(T.u, { u: u, m: m }).replace(/\s0\s\S+$/, '') : f(T.m, { m: Math.max(1, m) }); }

  /* ---------- levering: laatste bezorgdag over alle regels, aftellen alleen als alle regels vandaag nog weg kunnen ---------- */
  function levering(d) {
    var L = window.LP_LEVERTIJD;
    if (!L || !L.datum || !d || !d.regels || !d.regels.length) return null;
    var van = null, tot = null, min = Infinity, alleMin = true, vv = {}, vandaag = null, ok = true;
    d.regels.forEach(function (r) {
      var x = null;
      try { x = L.datum({ vendor: r.vendor, bol: r.bol, profiel: r.profiel, template: r.template }); } catch (e) {}
      if (!x) { ok = false; return; }
      r._lev = x; vandaag = x.vandaag;
      if (!van || x.van > van) van = x.van;
      if (!tot || x.tot > tot) tot = x.tot;
      if (x.minuten) min = Math.min(min, x.minuten); else alleMin = false;
      if (x.vervoerder) vv[x.vervoerder] = 1;
    });
    if (!ok || !van) return null;
    return { van: van, tot: tot, bereik: van.getTime() !== tot.getTime(), vandaag: vandaag, minuten: alleMin && min < Infinity ? min : null, vervoerders: Object.keys(vv) };
  }
  function zin(lv) {
    if (!lv) return '';
    if (lv.bereik) {
      var r = kort(lv.van) + ' – ' + kort(lv.tot);
      return lv.minuten ? f(T.binnen_bereik, { x: duur(lv.minuten), d: r }) : f(T.bereik, { d: r });
    }
    var d = dagWoord(lv.vandaag, lv.van);
    return lv.minuten ? f(T.binnen, { x: duur(lv.minuten), d: d }) : f(T.nu, { d: d });
  }
  function vervoer(lv) { return lv && lv.vervoerders.length ? f(T.verzending, { v: lv.vervoerders.join(' + ') }) : ''; }
  // alleen als Shopify de voorraad telt en er genoeg is voor het gekozen aantal
  function voorraad(r) {
    if (!r.geteld || r.voorraad == null || r.voorraad <= 0 || r.voorraad < r.q) return '';
    return r.voorraad <= 10 ? f(T.nog, { n: r.voorraad }) : T.op_voorraad;
  }
  function allesVoorraad(d) { return d.regels.length > 0 && d.regels.every(function (r) { return !!voorraad(r); }); }
  function verzendBalk(d, c) {
    var g = grens(c); if (!g) return null;
    var r = rate(), gc = Math.round(g.g * 100 * r), mc = Math.round((g.m || 0) * 100 * r);
    if (mc > 0 && d.totaal < mc) return { t: f(T.minimum, { land: naam(c), x: geld(mc - d.totaal) }), pct: d.totaal / mc };
    if (d.totaal >= gc) return { t: f(T.gratis, { land: naam(c) }), pct: 1, ok: true };
    return { t: f(T.tot_gratis, { x: geld(gc - d.totaal) }), pct: d.totaal / gc };
  }
  function herstelLink(d) {
    return location.origin + ROOT + 'cart?lp_wagen=' + d.regels.map(function (r) { return r.id + ':' + r.q; }).join(';');
  }
  function img(u, w) {
    if (!u) return '';
    u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u;
    try { var x = new URL(u, location.href); x.searchParams.set('width', String(w)); return x.toString(); } catch (e) { return ''; }
  }

  /* ---------- iconen ---------- */
  var IC = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    terug: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10h11a5 5 0 0 1 0 10H9"/><path d="M8 6l-4 4 4 4"/></svg>',
    slot: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    keur: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M8.5 12l2.5 2.5 4.5-4.5"/></svg>',
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#25D366" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2z"/><path fill="#fff" d="M17.2 14.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.6.1l-.9 1.1c-.2.2-.3.2-.6.1a7.6 7.6 0 0 1-3.8-3.3c-.3-.5.3-.5.8-1.6.1-.2 0-.4 0-.5l-.9-2c-.2-.6-.5-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.2.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 1.8.8 2.5.8 3.4.7.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',
    kopie: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>'
  };

  /* ---------- 3. popup ---------- */
  var OPEN = false, BEZIG = false, LAATST = 0, START = Date.now(), TIK = null;
  var TEST = qs.get('lp_vn') === 'test';
  function bannerZichtbaar() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var s = getComputedStyle(b);
    return !(s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') && b.getBoundingClientRect().height > 0;
  }
  function magNiet(dwing) {
    if (!EL || OPEN || BEZIG) return true;
    if (TEST || dwing) return false;
    if (navigator.webdriver) return true;
    if (ss('lp_vn')) return true;
    var t = +ls('lp_vn_t') || 0;
    if (Date.now() - t < 864e5) return true;
    if (Date.now() - START < 6000) return true;
    if (Date.now() - LAATST < 20000) return true;
    // 30-10-2026 (Bas): ook tonen als de cookiemelding nog openstaat (veel bezoekers klikken die nooit weg); de popup ligt erboven
    if (document.querySelector('.lp-popup.is-open')) return true;
    return false;
  }
  function inhoud(d, c) {
    var lv = levering(d), alles = allesVoorraad(d), vb = verzendBalk(d, c);
    var h = '<p class="lp-vn__kop" id="lp-vn-kop">' + esc(alles ? T.kop_voorraad : T.kop) + '</p>';
    if (lv) h += '<div class="lp-vn__lev">' + IC.truck + '<div><strong data-vn-zin>' + esc(zin(lv)) + '</strong>' + (vervoer(lv) ? '<span>' + esc(vervoer(lv)) + '</span>' : '') + '</div></div>';
    // regels: max 3 zichtbaar; levertijd per regel alleen als die verschilt
    var verschil = false;
    if (lv) d.regels.forEach(function (r) { if (r._lev && (r._lev.van.getTime() !== lv.van.getTime() || r._lev.tot.getTime() !== lv.tot.getTime())) verschil = true; });
    h += '<ul class="lp-vn__lijst">';
    d.regels.slice(0, 3).forEach(function (r) {
      var vr = voorraad(r), dl = '';
      if (verschil && r._lev) dl = r._lev.van.getTime() === r._lev.tot.getTime() ? dagWoord(r._lev.vandaag, r._lev.van) : kort(r._lev.van) + ' – ' + kort(r._lev.tot);
      h += '<li>' + (r.img ? '<img src="' + esc(img(r.img, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="lp-vn__geenimg"></span>') +
        '<div class="lp-vn__r"><span class="lp-vn__t">' + (r.q > 1 ? '<b>' + r.q + '×</b> ' : '') + esc(r.titel) + (r.variant ? ' <em>' + esc(r.variant) + '</em>' : '') + '</span>' +
        (vr || dl ? '<span class="lp-vn__chips">' + (vr ? '<span class="lp-vn__chip">' + IC.check + esc(vr) + '</span>' : '') + (dl ? '<span class="lp-vn__chip lp-vn__chip--dag">' + IC.truck + esc(dl) + '</span>' : '') + '</span>' : '') +
        '</div></li>';
    });
    h += '</ul>';
    if (d.regels.length > 3) h += '<p class="lp-vn__meer">' + esc(f(T.meer, { n: d.regels.length - 3 })) + '</p>';
    if (vb) h += '<div class="lp-vn__vz' + (vb.ok ? ' is-ok' : '') + '"><span>' + (vb.ok ? IC.check : '') + esc(vb.t) + '</span><i style="--p:' + Math.min(100, Math.round(vb.pct * 100)) + '%"></i></div>';
    var betaal = c === 'NL' ? T.betaal_nl : (c === 'BE' ? T.betaal_be : T.betaal);
    var wa = 'https://wa.me/' + (CFG.wa || '31418726800') + '?text=' + encodeURIComponent(T.wa_tekst || '');
    h += '<ul class="lp-vn__trust"><li>' + IC.terug + esc(T.bedenk) + '</li><li>' + IC.slot + esc(betaal) + '</li><li>' + IC.keur + esc(T.keur) + '</li>' +
      '<li><a href="' + esc(wa) + '" target="_blank" rel="noopener">' + IC.wa + esc(T.vraag) + '</a></li></ul>';
    h += '<div class="lp-vn__knoppen"><a class="lp-vn__af" href="' + esc(ROOT + 'checkout') + '">' + esc(T.afrekenen) + ' →</a>' +
      '<button type="button" class="lp-vn__verder" data-vn-dicht>' + esc(T.verder) + '</button></div>';
    h += '<button type="button" class="lp-vn__mailopen" data-vn-mailopen>' + IC.mail + esc(T.mail_open) + '</button>';
    return { html: h, lv: lv };
  }
  function deelRij(d) {
    var link = herstelLink(d), tekst = (T.deel_tekst || '') + '\n' + link;
    return '<div class="lp-vn__deel"><span>' + esc(T.delen) + '</span>' +
      '<a href="https://wa.me/?text=' + esc(encodeURIComponent(tekst)) + '" target="_blank" rel="noopener">' + IC.wa + esc(T.wa) + '</a>' +
      '<a href="mailto:?subject=' + esc(encodeURIComponent(T.mail_titel || '')) + '&amp;body=' + esc(encodeURIComponent(tekst)) + '">' + IC.mail + esc(T.mail) + '</a>' +
      '<button type="button" data-vn-kopie="' + esc(link) + '">' + IC.kopie + esc(T.kopie) + '</button>' +
      '<span class="lp-vn__gek" hidden>✓ ' + esc(T.gekopieerd) + '</span></div>';
  }
  function openMail(fout) {
    var m = EL.querySelector('[data-vn-mail]'), b = EL.querySelector('[data-vn-mailopen]');
    m.hidden = false; if (b) b.hidden = true;
    if (fout) { var fo = EL.querySelector('[data-vn-fout]'); fo.textContent = T.fout; fo.hidden = false; }
    setTimeout(function () { var i = EL.querySelector('[data-vn-email]'); if (i) i.focus({ preventScroll: false }); }, 50);
  }
  function toon(d, c, fout) {
    var r = inhoud(d, c);
    EL.querySelector('[data-vn-inhoud]').innerHTML = r.html;
    EL.querySelector('[data-vn-deel]').innerHTML = deelRij(d);
    EL.querySelector('[data-vn-mail]').hidden = true;
    var x = EL.querySelector('.lp-vn__x'); x.setAttribute('aria-label', T.sluit || 'Sluiten');
    EL.hidden = false; OPEN = true;
    requestAnimationFrame(function () { EL.classList.add('is-open'); });
    document.addEventListener('keydown', toets);
    setTimeout(function () { var a = EL.querySelector('.lp-vn__af'); if (a) a.focus({ preventScroll: true }); }, 280);
    if (fout) openMail(true);
    clearInterval(TIK);
    if (r.lv && r.lv.minuten) TIK = setInterval(function () {
      var lv = levering(DATA), z = EL.querySelector('[data-vn-zin]');
      if (lv && z) z.textContent = zin(lv);
    }, 30000);
    if (!TEST) ss('lp_vn', '1');
  }
  function dicht() {
    if (!OPEN) return;
    EL.classList.remove('is-open'); OPEN = false; clearInterval(TIK);
    setTimeout(function () { EL.hidden = true; }, 250);
    document.removeEventListener('keydown', toets);
    if (!TEST) ls('lp_vn_t', String(Date.now()));
  }
  function toets(e) { if (e.key === 'Escape') dicht(); }
  function probeer(fout) {
    if (magNiet(fout)) return;
    BEZIG = true; LAATST = Date.now();
    haal().then(function (d) {
      BEZIG = false;
      if (!d || !d.aantal || !d.regels.length) return;
      var c = land();
      if (!grens(c)) return;     // geen levering naar dit land (ook: bots uit VS/Brazilie e.d.)
      toon(d, c, fout);
    }).catch(function () { BEZIG = false; });
  }
  if (EL) {
    EL.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-vn-dicht]')) { e.preventDefault(); dicht(); return; }
      if (t.closest('[data-vn-mailopen]')) { e.preventDefault(); openMail(false); return; }
      var k = t.closest('[data-vn-kopie]');
      if (k) {
        var link = k.getAttribute('data-vn-kopie'), gek = EL.querySelector('.lp-vn__gek');
        var klaar = function () { if (gek) { gek.hidden = false; setTimeout(function () { gek.hidden = true; }, 2500); } };
        (navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(link) : Promise.reject()).then(klaar, function () { window.prompt(T.kopie || '', link); });
      }
    });
    // formulier
    var form = EL.querySelector('form');
    if (form) {
      var mk = EL.querySelector('[data-vn-mkop]'), mu = EL.querySelector('[data-vn-muitleg]'), em = EL.querySelector('[data-vn-email]'), kn = EL.querySelector('[data-vn-knop]');
      if (mk) mk.textContent = T.mail_kop || ''; if (mu) mu.textContent = T.mail_uitleg || '';
      if (em) { em.placeholder = T.email || ''; em.setAttribute('aria-label', T.email || ''); }
      if (kn) kn.textContent = T.knop || '';
      form.addEventListener('submit', function () {
        if (DATA) form.querySelector('[data-vn-tags]').value = tags(DATA).join(', ');
        form.querySelector('[data-vn-terug]').value = location.pathname + '?lp_vn_ok=1&customer_posted=true';
        ls('lp_popup_done', '1');
      });
    }
  }
  /* zelfde opbouw als assets/lp-toolmail.js (automatisering 'Toolmail' leest deze tags) */
  function tags(d) {
    var run = String(Math.floor(Date.now() / 1000)), p = 'tm-' + run + '-';
    var t = ['toolmail', 'tm-run:' + run, p + 'tool:winkelwagen', p + 'taal:' + TAAL, p + 'titel:' + (T.mail_titel || 'LEDPLANET.NL')];
    var l = herstelLink(d).replace(/,/g, '%2C');
    for (var i = 0, n = 1; i < l.length && n <= 16; i += 230, n++) t.push(p + 'l' + n + ':' + l.slice(i, i + 230));
    var EEN = { nl: '1 artikel, {x}', de: '1 Artikel, {x}', en: '1 item, {x}', fr: '1 article, {x}', es: '1 artículo, {x}', it: '1 articolo, {x}', pl: '1 produkt, razem {x}' };   // enkelvoud (30-10-2026)
    t.push(p + 's1:' + f(d.aantal === 1 ? (EEN[TAAL] || EEN.nl) : T.s_totaal, { n: d.aantal, x: geld(d.totaal) }));
    t.push(p + 's2:' + T.s_bewaard);
    d.regels.slice(0, 6).forEach(function (r, j) {
      var k = j + 1;
      t.push(p + 'p' + k + ':' + r.handle);
      var titel = (r.q > 1 ? r.q + '× ' : '') + r.titel + (r.variant ? ' – ' + r.variant : '');
      t.push(p + 'pt' + k + ':' + (titel.replace(/\|/g, '/').slice(0, 170) + '|' + geld(r.prijs)).slice(0, 220));
      var im = img(r.img, 300);
      if (im && im.length <= 225) t.push(p + 'pi' + k + ':' + im);
    });
    return t.map(function (x) { return x.replace(/,/g, ';').slice(0, 250); });
  }

  /* triggers */
  if (EL) {
    // pc: muis verlaat de pagina aan de bovenkant (tabbladen / adresbalk / sluiten)
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) probeer(); });
    // telefoon/tablet (alleen touch, niet bij scrollen met muis op de pc - 30-10-2026): na wat lezen snel omhoog vegen
    var touch = false;
    try { touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch (e) {}
    var maxY = 0, lastY = window.scrollY, lastT = Date.now();
    if (touch) window.addEventListener('scroll', function () {
      var y = window.scrollY, t = Date.now();
      if (y > maxY) maxY = y;
      if (maxY > 700 && lastY - y > 250 && t - lastT < 400) probeer();
      if (t - lastT > 400 || y > lastY) { lastY = y; lastT = t; }
    }, { passive: true });
    // winkelwagenpagina: 40 seconden niets doen
    if (CFG.type === 'cart') {
      var stil = null;
      var reset = function () { clearTimeout(stil); stil = setTimeout(function () { probeer(); }, 40000); };
      ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (ev) { window.addEventListener(ev, reset, { passive: true }); });
      reset();
    }
    if (FOUT) setTimeout(function () { ss('lp_vn', ''); probeer(true); }, 800);
    if (TEST) setTimeout(function () { probeer(); }, 1200);
  }

  /* ---------- 4. vaste regel in de winkelwagen (lade en pagina) ---------- */
  var VKEY = '';
  function vastTekst(d, c) {
    if (!d || !d.aantal || !grens(c)) return '';
    var lv = levering(d), alles = allesVoorraad(d);
    if (!lv && !alles) return '';
    return '<div class="lp-vn-vast__in">' + IC.truck + '<div>' + (lv ? '<strong data-vn-zin>' + esc(zin(lv)) + '</strong>' : '') +
      '<span>' + (alles ? IC.check + esc(T.vast_voorraad) : '') + (alles && vervoer(lv) ? ' · ' : '') + esc(vervoer(lv)) + '</span></div></div>';
  }
  function vastZet() {
    var notes = document.querySelectorAll('.free-shipping-notice[data-lp-tot]');
    if (!notes.length || !DATA) return;
    var c = land(), html = vastTekst(DATA, c);
    notes.forEach(function (n) {
      var b = n.nextElementSibling;
      if (!b || !b.classList || !b.classList.contains('lp-vn-vast')) { b = document.createElement('div'); b.className = 'lp-vn-vast'; n.parentNode.insertBefore(b, n.nextSibling); }
      if (b.innerHTML !== html) b.innerHTML = html;
      b.hidden = !html;
    });
  }
  function vastSleutel() {
    var s = [];
    document.querySelectorAll('.free-shipping-notice[data-lp-tot]').forEach(function (n) { s.push(n.getAttribute('data-lp-tot') + (n.nextElementSibling && n.nextElementSibling.classList && n.nextElementSibling.classList.contains('lp-vn-vast') ? '+' : '-')); });
    return s.join('|');
  }
  var vgepland = null;
  function vastCheck() {
    clearTimeout(vgepland);
    vgepland = setTimeout(function () {
      var k = vastSleutel();
      if (!k || k === VKEY) return;
      var leeg = true;
      document.querySelectorAll('.free-shipping-notice[data-lp-tot]').forEach(function (n) { if (n.getAttribute('data-lp-leeg') !== '1') leeg = false; });
      if (leeg) {   // lege winkelwagen: niets ophalen, regel verbergen
        document.querySelectorAll('.lp-vn-vast').forEach(function (b) { b.hidden = true; });
        VKEY = k; DATA = DATA && DATA.aantal ? null : DATA; return;
      }
      var totNu = k.replace(/[+-]/g, ''), totOud = VKEY.replace(/[+-]/g, '');
      VKEY = k;
      if (DATA && totNu === totOud) { vastZet(); VKEY = vastSleutel(); return; }   // alleen opnieuw opgebouwd: geen nieuwe fetch
      haal().then(function () { vastZet(); VKEY = vastSleutel(); }).catch(function () {});
    }, 450);
  }
  function startVast() {
    vastCheck();
    if (window.MutationObserver) new MutationObserver(vastCheck).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('lp:levertijd-update', function () { setTimeout(vastZet, 60); });
    setInterval(function () {   // aftellen bijwerken zonder nieuwe fetch
      if (!DATA) return;
      var lv = levering(DATA);
      document.querySelectorAll('.lp-vn-vast [data-vn-zin]').forEach(function (z) { if (lv) z.textContent = zin(lv); });
    }, 30000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startVast); else startVast();
})();
